import { ref } from 'vue';

function triggerBlobDownload(data, filename) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

export function useTokenTransactionDownloads() {
    const loadingDownload = ref(false);
    const loadingDownloadSelected = ref(false);

    function download(transaction) {
        transaction.downloading = true;
        axios({
            url: '/token-transactions/' + transaction.id + '/confirmation',
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            saveAs(response.data, `potwierdzenie-transakcji-${transaction.id}.pdf`);
        }).finally(() => {
            transaction.downloading = false;
        });
    }

    async function downloadAllConfirmations(filters, companyId, administrationTransactions = null) {
        loadingDownload.value = true;
        try {
            const response = await axios.get('/token-transactions/export-confirmations', {
                responseType: 'blob',
                params: { filters, company_id: companyId, administration_transactions: administrationTransactions ? 1 : 0 },
            });
            triggerBlobDownload(response.data, 'confirmations.zip');
        } finally {
            loadingDownload.value = false;
        }
    }

    async function downloadSelectedConfirmations(selectedIds, administrationTransactions = null) {
        if (selectedIds.length === 0) return;
        loadingDownloadSelected.value = true;
        try {
            const response = await axios.get('/token-transactions/export-confirmations', {
                responseType: 'blob',
                params: { ids: selectedIds, administration_transactions: administrationTransactions ? 1 : 0 },
            });
            triggerBlobDownload(response.data, 'confirmations-selected.zip');
        } finally {
            loadingDownloadSelected.value = false;
        }
    }

    return {
        loadingDownload,
        loadingDownloadSelected,
        download,
        downloadAllConfirmations,
        downloadSelectedConfirmations,
    };
}
